














































import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import { SelectableTag } from "@api/models/SelectableTag";
import TagList from "@share/common/tag-list/TagList.vue";
import DarkModalWindow from "@service/components/modal/DarkModal.vue";
import RadioButton from "@share/common/controls/radio/RadioButton.vue";
import { TicketType } from "@share/ticketSystem/enums/TicketTypes";
import { SubjectTypeFilterState } from "@share/committees/committees-list/types/filterTypes";

@Component({
    name: 'FilterModal',
    components: { TagList, DarkModalWindow, RadioButton }
})
export default class FilterModal extends Vue {
    @Prop({ default: [] }) tags: SelectableTag[];
    @Prop({}) subjectType: SubjectTypeFilterState;

    subjectTypeValue: SubjectTypeFilterState = "all";

    created() {
        this.subjectTypeValue = this.subjectType;
    }

    @Watch("subjectTypeValue")
    watchSubjectTypeValue(value: SubjectTypeFilterState) {
        this.$emit('updateSubjectType', value)
    }

    TicketType = TicketType;

    getChildTags(parentId: string): SelectableTag[] {
        return this.tags.filter(tag => tag.tag.parentId === parentId)
    }

    applyFilters() {
        this.$emit('apply')
    }

    resetFilters() {
        this.$emit('reset');
    }

    accumulateTag(eventItem: SelectableTag) {
        this.$emit('accumulateTag', eventItem);
    }
}
